import {
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  TextField,
  Tooltip,
  Typography,
  Checkbox,
  Chip,
  FormControlLabel,
} from "@mui/material";
import {
  Cancel,
  Check,
  KeyboardReturn,
  Update,
  Visibility,
  List,
} from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import SaveIcon from "@mui/icons-material/Save";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { Add } from "@mui/icons-material";
import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import {
  getLcListaPrecio,
  saveLcListaPrecio,
} from "../../services/LcListaPrecioService.js";
import { getCacheData } from "../../services/CacheService";
import Message from "../../utils/Message.jsx";
import WaitingDialog from "../../utils/WaitingDialog.jsx";
import RangoDialog from "./RangoDialog.jsx";
import CorreccionesDialog from "./CorreccionesDialog.jsx";
import { formatMoney } from "../../utils/utils";

const initialState = {
  id: null,
  idProveedor: null,
  idLcProducto: null,
  ventaPorUnidad: false,
  idLcCurvas: [],
  idLcDiametros: [],
  rangosList: [],
  observaciones: "",
};

const nameItemsText = "Lista de Precio de Lente de Contacto";
//
// ##########################################################################
//
const ListaPrecioLenteContacto = () => {
  const navigate = useNavigate();
  const params = useParams();
  const idLcLprecio = params.idLcLprecio;
  const action = params.action;
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [listaPrecioData, setListaPrecioData] = useState(initialState);
  const [rangosList, setRangosList] = useState([]);
  const [openRangoDialog, setOpenRangoDialog] = useState(false);
  const [actionCrud, setActionCrud] = useState("");
  const [actionRangoDialog, setActionRangoDialog] = useState("");
  const [actionCorreccionesDialog, setActionCorreccionesDialog] = useState("");
  const [openCorreccionesDialog, setOpenCorreccionesDialog] = useState(false);
  const [itemCrud, setItemCrud] = useState(initialState);
  const [titleComponent, setTitleComponent] = useState("");
  const [proveedores, setProveedores] = useState([]);
  const [lcProductos, setLcProductos] = useState([]);
  const [lcPresentaciones, setLcPresentaciones] = useState([]);
  const [lcCurvas, setLcCurvas] = useState([]);
  const [lcDiametros, setLcDiametros] = useState([]);
  const curvasUserChangedRef = useRef(false);
  const diametrosUserChangedRef = useRef(false);

  const [valueACProveedor, setValueACProveedor] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACProveedor, setInputValueACProveedor] = useState("");

  const [valueACLcProducto, setValueACLcProducto] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACLcProducto, setInputValueACLcProducto] = useState("");

  const [valueACLcPresentacion, setValueACLcPresentacion] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACLcPresentacion, setInputValueACLcPresentacion] =
    useState("");

  const [valueACLcCurva, setValueACLcCurva] = useState([]);
  const [inputValueACLcCurva, setInputValueACLcCurva] = useState("");
  const [valueACLcDiametro, setValueACLcDiametro] = useState([]);
  const [inputValueACLcDiametro, setInputValueACLcDiametro] = useState("");
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const curvasOptionsWithActions = useMemo(() => {
    return [
      { id: "__toggle_all__", label: "Seleccionar todos", __action: true },
      ...lcCurvas,
    ];
  }, [lcCurvas]);

  const diametrosOptionsWithActions = useMemo(() => {
    return [
      { id: "__toggle_all__", label: "Seleccionar todos", __action: true },
      ...lcDiametros,
    ];
  }, [lcDiametros]);

  const tableColumns = [
    {
      field: "esfera_desde",
      headerName: "Desde Esfera",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.esfera_desde);
      },
    },
    {
      field: "esfera_hasta",
      headerName: "Hasta Esfera",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.esfera_hasta);
      },
    },
    {
      field: "cilindro_desde",
      headerName: "Desde Cilindro",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.cilindro_desde);
      },
    },
    {
      field: "cilindro_hasta",
      headerName: "Hasta Cilindro",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.cilindro_hasta);
      },
    },
    {
      field: "costo_real",
      headerName: "Costo Real",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.costo_real);
      },
    },
    {
      field: "precio_venta_contado",
      headerName: "PV Contado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.precio_venta_contado);
      },
    },
    {
      field: "precio_venta_lista",
      headerName: "PV Lista",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return formatMoney(params.row.precio_venta_lista);
      },
    },
    {
      field: "cantidad_correcciones",
      headerName: "Correcciones",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.correcciones_list.length || 0;
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      width: 180,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <>
          {["new", "update"].includes(action) && (
            <>
              <Tooltip title="editar rango">
                <IconButton
                  size="small"
                  aria-label="edit"
                  onClick={() => handleClickRango(params.row, "update")}
                >
                  <EditOutlinedIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="eliminar rango">
                <IconButton
                  size="small"
                  aria-label="delete"
                  onClick={() => handleClickRango(params.row, "delete")}
                >
                  <RemoveCircleOutlineIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="correcciones">
                <IconButton
                  size="small"
                  aria-label="delete"
                  onClick={() => handleClickCorrecciones(params.row, "update")}
                >
                  <List />
                </IconButton>
              </Tooltip>
            </>
          )}

          {["enable", "disable", "mark-as-reference"].includes(action) && (
            <Tooltip title="ver rango">
              <IconButton
                size="small"
                aria-label="view"
                onClick={() => handleClickRango(params.row, "view")}
              >
                <RemoveRedEyeOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const tableOptions = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    disableRowSelectionOnClick: true,
    getRowId: (row) => row.id_articulo || row.id,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };
  //
  // ##########################################################################
  //
  useEffect(() => {
    setActionCrud(action);
    loadProveedores();
    loadLcProductos();
    loadLcPresentaciones();
    loadLcCurvas();
    loadLcDiametros();

    if (action === "new") {
      setTitleComponent("Nueva " + nameItemsText);
      setListaPrecioData((prev) => ({ ...prev, ventaPorUnidad: true }));
    } else {
      load();
    }
  }, []);
  //
  // ##########################################################################
  //
  useEffect(() => {
    if (curvasUserChangedRef.current) return;
    if (
      (action === "update" ||
        action === "disable" ||
        action === "view" ||
        action === "enable" ||
        action === "mark-as-reference") &&
      Array.isArray(lcCurvas) &&
      lcCurvas.length > 0
    ) {
      const sourceList = (listaPrecioData && listaPrecioData.curvas_list) || [];
      if (Array.isArray(sourceList) && sourceList.length > 0) {
        const selectedIds = sourceList
          .map((it) => {
            if (it && typeof it === "object") {
              return it.id_lc_curva || it.id;
            }
            return it;
          })
          .filter(Boolean);
        const selectedOptions = lcCurvas.filter((opt) =>
          selectedIds.includes(opt.id),
        );
        if (selectedOptions.length > 0) {
          setValueACLcCurva(selectedOptions);
          return;
        }
      }
      if (listaPrecioData && listaPrecioData.idLcCurvas) {
        const selected = lcCurvas.find(
          (opt) => opt.id === listaPrecioData.idLcCurvas,
        );
        if (selected) {
          setValueACLcCurva([selected]);
        }
      }
    }
  }, [action, listaPrecioData, lcCurvas]);

  //
  // ##########################################################################
  //
  useEffect(() => {
    if (diametrosUserChangedRef.current) return;
    if (
      (action === "update" ||
        action === "disable" ||
        action === "view" ||
        action === "enable" ||
        action === "mark-as-reference") &&
      Array.isArray(lcDiametros) &&
      lcDiametros.length > 0
    ) {
      const sourceList = (listaPrecioData && listaPrecioData.diametros_list) || [];
      if (Array.isArray(sourceList) && sourceList.length > 0) {
        const selectedIds = sourceList
          .map((it) => {
            if (it && typeof it === "object") {
              return it.id_lc_diametro || it.id;
            }
            return it;
          })
          .filter(Boolean);
        const selectedOptions = lcDiametros.filter((opt) =>
          selectedIds.includes(opt.id),
        );
        if (selectedOptions.length > 0) {
          setValueACLcDiametro(selectedOptions);
          return;
        }
      }
      if (listaPrecioData && listaPrecioData.idLcDiametros) {
        const selected = lcDiametros.find(
          (opt) => opt.id === listaPrecioData.idLcDiametros,
        );
        if (selected) {
          setValueACLcDiametro([selected]);
        }
      }
    }
  }, [action, listaPrecioData, lcDiametros]);
  //
  // ##########################################################################
  //
  const allCurvasSelected = useMemo(() => {
    return (
      Array.isArray(lcCurvas) &&
      lcCurvas.length > 0 &&
      Array.isArray(valueACLcCurva) &&
      valueACLcCurva.length === lcCurvas.length
    );
  }, [lcCurvas, valueACLcCurva]);

  //
  // ##########################################################################
  //
  const handleSelectAllCurvas = () => {
    if (Array.isArray(lcCurvas) && lcCurvas.length > 0) {
      setValueACLcCurva(lcCurvas);
    }
  };
  //
  // ##########################################################################
  //
  const handleClearAllCurvas = () => {
    setValueACLcCurva([]);
  };
  //
  // ##########################################################################
  //
  const allDiametrosSelected = useMemo(() => {
    return (
      Array.isArray(lcDiametros) &&
      lcDiametros.length > 0 &&
      Array.isArray(valueACLcDiametro) &&
      valueACLcDiametro.length === lcDiametros.length
    );
  }, [lcDiametros, valueACLcDiametro]);

  //
  // ##########################################################################
  //
  const handleSelectAllDiametros = () => {
    if (Array.isArray(lcDiametros) && lcDiametros.length > 0) {
      setValueACLcDiametro(lcDiametros);
    }
  };
  //
  // ##########################################################################
  //
  const handleClearAllDiametros = () => {
    setValueACLcDiametro([]);
  };
  //
  // ##########################################################################
  //
  const handleCancelar = () => {
    navigate("/lc-lprecio-table");
  };
  //
  // ##########################################################################
  //
  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setListaPrecioData({
      ...listaPrecioData,
      [name]: value,
    });
  };
  //
  // ##########################################################################
  //
  const handleClickRango = (parRango, parAction) => {
    let _itemCrud = {};
    _itemCrud = {
      id: parRango.id,
      esferaDesde: parRango.esfera_desde,
      esferaHasta: parRango.esfera_hasta,
      cilindroDesde: parRango.cilindro_desde,
      cilindroHasta: parRango.cilindro_hasta,
      costoPesos: parRango.costo_pesos ? parRango.costo_pesos.toFixed(2) : 0,
      costoDolares: parRango.costo_dolares
        ? parRango.costo_dolares.toFixed(4)
        : 0,
      valorDolar: parRango.valor_dolar ? parRango.valor_dolar.toFixed(2) : 0,
      porcentajeDescuento: parRango.porcentaje_descuento
        ? parRango.porcentaje_descuento.toFixed(2)
        : 0,
      costoReal: parRango.costo_real ? parRango.costo_real.toFixed(2) : 0,
      futContado: parRango.fut_contado ? parRango.fut_contado.toFixed(1) : 0,
      precioVentaContado: parRango.precio_venta_contado
        ? parRango.precio_venta_contado.toFixed(2)
        : 0,
      futLista: parRango.fut_lista ? parRango.fut_lista.toFixed(1) : 0,
      precioVentaLista: parRango.precio_venta_lista
        ? parRango.precio_venta_lista.toFixed(2)
        : 0,
      correccionesList: parRango.correcciones_list,
    };
    setActionRangoDialog(parAction);
    setItemCrud(_itemCrud);
    setOpenRangoDialog(true);
  };
  //
  // ##########################################################################
  //
  const handleClickCorrecciones = (parRango, parAction) => {
    let _rango = {
      id: parRango.id,
      esferaDesde: parRango.esfera_desde,
      esferaHasta: parRango.esfera_hasta,
      cilindroDesde: parRango.cilindro_desde,
      cilindroHasta: parRango.cilindro_hasta,
      correccionesList: parRango.correcciones_list,
    };
    setActionCorreccionesDialog(parAction);
    setItemCrud(_rango);
    setOpenCorreccionesDialog(true);
  };
  //
  // ##########################################################################
  //
  const handleSave = async (parAction) => {
    // Resta probar... ya quedo lo de las correcciones...
    // Falta Arreglar lo de rangos... que funcione todo ok..
    // Falta habilitar y deshabilitar... tambien probar que funcione todo ok..

    if (
      valueACProveedor.id === "" ||
      valueACProveedor.id === null ||
      valueACProveedor.id === undefined
    ) {
      setMessage({
        messageText: "Debes seleccionar el Proveedor",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (
      valueACLcProducto.id === "" ||
      valueACLcProducto.id === null ||
      valueACLcProducto.id === undefined
    ) {
      setMessage({
        messageText: "Debes seleccionar el Producto",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (
      valueACLcPresentacion.id === "" ||
      valueACLcPresentacion.id === null ||
      valueACLcPresentacion.id === undefined
    ) {
      setMessage({
        messageText: "Debes seleccionar la Presentación",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    // chequeo si se ha seleccionado al menos una Curva

    const selectedCurvasCount = Array.isArray(valueACLcCurva)
      ? valueACLcCurva.length
      : 0;
    const existingCurvasCount =
      (listaPrecioData.curvasList && listaPrecioData.curvasList.length) ||
      (listaPrecioData.idLcCurvas && listaPrecioData.idLcCurvas.length) ||
      0;
    if (selectedCurvasCount === 0 && existingCurvasCount === 0) {
      setMessage({
        messageText: "Debes seleccionar al menos una Curva",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    const selectedDiametroCount = Array.isArray(valueACLcDiametro)
      ? valueACLcDiametro.length
      : 0;
    const existingDiametroCount =
      (listaPrecioData.diametrosList && listaPrecioData.diametrosList.length) ||
      (listaPrecioData.idLcDiametros && listaPrecioData.idLcDiametros.length) ||
      0;
    if (selectedDiametroCount === 0 && existingDiametroCount === 0) {
      setMessage({
        messageText: "Debes seleccionar al menos un Diámetro",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (rangosList.length === 0) {
      setMessage({
        messageText: "Debes agregar al menos un Rango a la Lista de Precios",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    // recorro rangosList .. en busca de si no trae el atributo correcciones_list sino lo trae lanzo Mensaje de error y salgo
    const _rangosSinCorrecciones = rangosList.filter(
      (r) => !r.correcciones_list || r.correcciones_list.length === 0,
    );
    if (
      _rangosSinCorrecciones.some(
        (r) => !r.correcciones_list || r.correcciones_list.length === 0,
      )
    ) {
      setMessage({
        messageText: "Debes ingresar correcciones para todos los rangos",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    let _object = {};
    let _rangosList = [];

    _rangosList = rangosList.map((item) => ({
      esfera_desde: item.esfera_desde,
      esfera_hasta: item.esfera_hasta,
      cilindro_desde: item.cilindro_desde,
      cilindro_hasta: item.cilindro_hasta,
      costo_pesos: item.costo_pesos,
      costo_dolares: item.costo_dolares,
      valor_dolar: item.valor_dolar,
      porcentaje_descuento: item.porcentaje_descuento,
      costo_real: item.costo_real,
      fut_contado: item.fut_contado,
      precio_venta_contado: item.precio_venta_contado,
      fut_lista: item.fut_lista,
      precio_venta_lista: item.precio_venta_lista,
      correcciones_list: item.correcciones_list.map((subitem) => ({
        esfera: subitem.esfera,
        cilindro: subitem.cilindro,
        eje: subitem.eje,
      })),
    }));

    _object = {
      id_proveedor: valueACProveedor.id,
      id_lente_contacto_producto: valueACLcProducto.id,
      id_lc_presentacion: valueACLcPresentacion.id,
      curvas_list: valueACLcCurva.map((item) => ({
        id_lc_curva: item.id,
      })),
      diametros_list: valueACLcDiametro.map((item) => ({
        id_lc_diametro: item.id,
      })),
      rangos_list: _rangosList,
      observaciones: listaPrecioData.observaciones?.toUpperCase() || "",
      venta_por_unidad: listaPrecioData.ventaPorUnidad,
      id_usuario: localStorage.getItem("id_usuario"),
    };
    if (parAction !== "new") {
      _object.id = listaPrecioData.id;
    }

    setIsDoingSomething(true);
    const response = await saveLcListaPrecio(parAction, _object);
    setIsDoingSomething(false);

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);

    if (response.ok) {
      setTimeout(() => {
        handleCancelar();
      }, 1000);
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const load = async () => {

    setIsDoingSomething(true);
    const response = await getLcListaPrecio({ id: idLcLprecio });
    setIsDoingSomething(false);

    if (response.ok) {
      let _response = response.data.data;
      if (action === "update") {
        setTitleComponent("Editando " + nameItemsText);
      } else if (action === "disable") {
        setTitleComponent("Deshabilitando " + nameItemsText);
      } else if (action === "enable") {
        setTitleComponent("Habilitando " + nameItemsText);
      } else if (action === "mark-as-reference") {
        setTitleComponent("Marcando como Lista de Precios de Referencia ");
      }

      setValueACProveedor({
        id: _response.id_proveedor,
        label:
          _response.descripcion_proveedor +
          (_response.contacto_proveedor
            ? " - " + _response.contacto_proveedor
            : ""),
      });
      setValueACLcProducto({
        id: _response.id_lente_contacto_producto,
        label: _response.descripcion_lente_contacto_producto,
      });
      setValueACLcPresentacion({
        id: _response.id_lc_presentacion,
        label: _response.descripcion_lc_presentacion,
      });
      setValueACLcCurva(
        _response.id_lc_curva
          ? [
            {
              id: _response.id_lc_curva,
              // cuando el valor es 0, se debe mostrar como 0.00
              label:
                _response.valor_lc_curva === 0
                  ? "0.00"
                  : _response.valor_lc_curva != null
                    ? Number(_response.valor_lc_curva).toFixed(2)
                    : "",
            },
          ]
          : [],
      );
      setValueACLcDiametro(
        _response.id_lc_diametro
          ? [
            {
              id: _response.id_lc_diametro,
              label:
                _response.valor_lc_diametro === 0
                  ? "0.00"
                  : _response.valor_lc_diametro != null
                    ? Number(_response.valor_lc_diametro).toFixed(2)
                    : "",
            },
          ]
          : [],
      );
      setRangosList(
        Array.isArray(_response.rangos_list) ? _response.rangos_list : [],
      );
      if (action === "new") {
        setListaPrecioData((prev) => ({ ...prev, ventaPorUnidad: true }));
      } else {
        setListaPrecioData({
          ..._response,
          // para tener en cuenta cuando es venta por unidad...
          ventaPorUnidad: _response.venta_por_unidad,
        });
      }
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadProveedores = async () => {
    const response = await getCacheData("proveedor")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label:
            item.descripcion + (item.contacto ? " - " + item.contacto : ""),
        });
      });
      setProveedores(_var);
    } else {
      setProveedores([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcCurvas = async () => {
    const response = await getCacheData("lc_curva")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.valor.toFixed(2),
        });
      });
      setLcCurvas(_var);
    } else {
      setLcCurvas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcDiametros = async () => {
    const response = await getCacheData("lc_diametro")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.valor.toFixed(2),
        });
      });
      setLcDiametros(_var);
    } else {
      setLcDiametros([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcProductos = async () => {
    const response = await getCacheData("lente_contacto_producto")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setLcProductos(_var);
    } else {
      setLcProductos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcPresentaciones = async () => {
    const response = await getCacheData("lc_presentacion")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setLcPresentaciones(_var);
    } else {
      setLcPresentaciones([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleCloseRango = () => {
    setOpenRangoDialog(false);
    setActionRangoDialog("");
  };
  //
  // ################################################################################
  //
  const handleCloseCorrecciones = () => {
    setOpenCorreccionesDialog(false);
    setActionCorreccionesDialog("");
  };
  //
  // ################################################################################
  //
  const handleSaveRango = (item, action) => {
    if (action === "delete") {
      // busco el cristal por su idLcProducto y lo quito de la lista
      const _varList = (rangosList || []).filter(
        (rango) => rango.id !== item.id,
      );
      setRangosList(_varList);
      setOpenRangoDialog(false);
      return;
    }

    // normalizo el objeto que viene del diálogo a la forma usada en la tabla/estado
    const _normalized = {
      id: item.id,
      esfera_desde: item.esfera_desde,
      esfera_hasta: item.esfera_hasta,
      cilindro_desde: item.cilindro_desde,
      cilindro_hasta: item.cilindro_hasta,
      costo_pesos: item.costo_pesos,
      costo_dolares: item.costo_dolares,
      valor_dolar: item.valor_dolar,
      porcentaje_descuento: item.porcentaje_descuento,
      costo_real: item.costo_real,
      fut_contado: item.fut_contado,
      precio_venta_contado: item.precio_venta_contado,
      fut_lista: item.fut_lista,
      precio_venta_lista: item.precio_venta_lista,
      correcciones_list: item.correcciones_list,
    };

    if (action === "update") {
      const _list = rangosList ? [...rangosList] : [];
      const idx = _list.findIndex((rango) => rango.id === item.id);
      if (idx >= 0) {
        _list[idx] = _normalized;
      } else {
        _list.push(_normalized);
      }
      setRangosList(_list);
    } else if (action === "new") {
      const _list = rangosList ? [...rangosList] : [];
      _list.push(_normalized);
      setRangosList(_list);
    }
  };
  //
  // ################################################################################
  //
  const handleSaveCorreccion = (item, action) => {
    // El diálogo devuelve el rango (item.id) y la lista completa de correcciones en item.correcciones_list
    // Actualizamos el rango correspondiente dentro de rangosList.
    const rangeId = item && item.id;
    const newCorrecciones = Array.isArray(item && item.correcciones_list)
      ? item.correcciones_list
      : [];

    if (!rangeId) {
      setMessage({
        messageText:
          "No se pudo identificar el rango para actualizar las correcciones",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    const list = rangosList ? [...rangosList] : [];
    const idx = list.findIndex((r) => r.id === rangeId);
    if (idx >= 0) {
      list[idx] = {
        ...list[idx],
        correcciones_list: newCorrecciones,
      };
      setRangosList(list);

      setOpenCorreccionesDialog(false);
    } else {
      // Si no se encuentra el rango, no rompemos nada: informamos y salimos.
      setMessage({
        messageText:
          "No se encontró el rango seleccionado para aplicar correcciones",
        severity: "error",
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={1} sx={{
        borderStyle: "solid",
        borderColor: "#e0e0e0",
        borderWidth: 1,
        p: 1,
        m: 1,
        maxWidth: "100%"
      }}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ m: 1, mb: 3 }}
            >
              <Typography variant="h5" display="block" gutterBottom >
                {titleComponent}
              </Typography>
            </Box>
          </Grid>

          <Grid container spacing={1} sx={{ ml: 1, mb: 2 }} >
            <Grid item xs={12} lg={6}>
              <Autocomplete
                id="id-proveedor"
                size="small"
                value={
                  valueACProveedor && valueACProveedor.id
                    ? valueACProveedor
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACProveedor(newValue);
                  setListaPrecioData({
                    ...listaPrecioData,
                    idProveedor: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACProveedor}
                onInputChange={(event, newInputValue) => {
                  setInputValueACProveedor(newInputValue);
                }}
                options={proveedores}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => (
                  <TextField {...params} label="Proveedor" />
                )}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={["view", "enable", "disable", "mark-as-reference"].includes(actionCrud)}
              />
            </Grid>

            <Grid item xs={12} lg={6}>
              <Autocomplete
                id="id-lc-producto"
                size="small"
                value={
                  valueACLcProducto && valueACLcProducto.id
                    ? valueACLcProducto
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACLcProducto(newValue);
                  setListaPrecioData({
                    ...listaPrecioData,
                    idLcProducto: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACLcProducto}
                onInputChange={(event, newInputValue) => {
                  setInputValueACLcProducto(newInputValue);
                }}
                options={lcProductos}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => (
                  <TextField {...params} label="Producto" />
                )}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={["view", "enable", "disable", "mark-as-reference"].includes(actionCrud)}
              />
            </Grid>

            <Grid item xs={12} lg={3}>
              <Autocomplete
                id="id-lc-presentacion"
                size="small"
                value={
                  valueACLcPresentacion && valueACLcPresentacion.id
                    ? valueACLcPresentacion
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACLcPresentacion(newValue);
                  setListaPrecioData({
                    ...listaPrecioData,
                    idLcPresentacion: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACLcPresentacion}
                onInputChange={(event, newInputValue) => {
                  setInputValueACLcPresentacion(newInputValue);
                }}
                options={lcPresentaciones}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => (
                  <TextField {...params} label="Presentación" />
                )}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={["view", "enable", "disable", "mark-as-reference"].includes(actionCrud)}
              />
            </Grid>

            <Grid item xs={12} lg={3}>
              <Autocomplete
                id="id-lc-curva"
                size="small"
                multiple
                limitTags={5}
                openOnFocus
                disableCloseOnSelect
                value={valueACLcCurva || []}
                onChange={(event, newValue, reason, details) => {
                  curvasUserChangedRef.current = true;
                  const lastOption =
                    details && details.option ? details.option : null;
                  if (lastOption && lastOption.__action) {
                    if (allCurvasSelected) {
                      handleClearAllCurvas();
                    } else {
                      handleSelectAllCurvas();
                    }
                    return;
                  }
                  setValueACLcCurva(newValue);
                }}
                inputValue={inputValueACLcCurva}
                onInputChange={(event, newInputValue) => {
                  setInputValueACLcCurva(newInputValue);
                }}
                options={curvasOptionsWithActions}
                isOptionEqualToValue={(option, value) => {
                  if (!option || !value) return false;
                  if (option.__action || value.__action)
                    return option.id === value.id;
                  return option.id === value.id;
                }}
                getOptionLabel={(option) => option.label || ""}
                renderTags={(selected, getTagProps) => {
                  const visibleChips = 3;
                  const chips = selected
                    .slice(0, visibleChips)
                    .map((option, index) => (
                      <Chip
                        {...getTagProps({ index })}
                        key={option.id}
                        label={option.label}
                        size="small"
                      />
                    ));
                  if (selected.length > visibleChips) {
                    chips.push(
                      <Chip
                        key="more"
                        label={`+${selected.length - visibleChips}`}
                        size="small"
                        disabled
                      />,
                    );
                  }
                  return chips;
                }}
                disableClearable={true}
                disabled={["view", "enable", "disable", "mark-as-reference"].includes(actionCrud)}
                renderOption={(props, option, { selected }) => {
                  const { key, ...optionProps } = props;
                  if (option.__action) {
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          indeterminate={
                            !allCurvasSelected &&
                            Array.isArray(valueACLcCurva) &&
                            valueACLcCurva.length > 0
                          }
                          checked={allCurvasSelected}
                          style={{ marginRight: 5 }}
                        />
                        {allCurvasSelected
                          ? "Desmarcar todos"
                          : "Marcar todos"}
                      </li>
                    );
                  }
                  return (
                    <li key={key} {...optionProps}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 5 }}
                        checked={selected}
                      />
                      {option.label}
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Curvas" />
                )}
              />
            </Grid>

            <Grid item xs={12} lg={3}>
              <Autocomplete
                id="id-lc-diametro"
                size="small"
                multiple
                limitTags={5}
                openOnFocus
                disableCloseOnSelect //
                value={valueACLcDiametro || []}
                onChange={(event, newValue, reason, details) => {
                  diametrosUserChangedRef.current = true;
                  const lastOption =
                    details && details.option ? details.option : null;
                  if (lastOption && lastOption.__action) {
                    if (allDiametrosSelected) {
                      handleClearAllDiametros();
                    } else {
                      handleSelectAllDiametros();
                    }
                    return;
                  }
                  setValueACLcDiametro(newValue);
                }}
                inputValue={inputValueACLcDiametro}
                onInputChange={(event, newInputValue) => {
                  setInputValueACLcDiametro(newInputValue);
                }}
                options={diametrosOptionsWithActions}
                isOptionEqualToValue={(option, value) => {
                  if (!option || !value) return false;
                  if (option.__action || value.__action)
                    return option.id === value.id;
                  return option.id === value.id;
                }}
                getOptionLabel={(option) => option.label || ""}
                renderTags={(selected, getTagProps) => {
                  const visibleChips = 3;
                  const chips = selected
                    .slice(0, visibleChips)
                    .map((option, index) => (
                      <Chip
                        {...getTagProps({ index })}
                        key={option.id}
                        label={option.label}
                        size="small"
                      />
                    ));
                  if (selected.length > visibleChips) {
                    chips.push(
                      <Chip
                        key="more"
                        label={`+${selected.length - visibleChips}`}
                        size="small"
                        disabled
                      />,
                    );
                  }
                  return chips;
                }}
                disableClearable={true}
                disabled={["view", "enable", "disable", "mark-as-reference"].includes(actionCrud)}
                renderOption={(props, option, { selected }) => {
                  const { key, ...optionProps } = props;
                  if (option.__action) {
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          indeterminate={
                            !allDiametrosSelected &&
                            Array.isArray(valueACLcDiametro) &&
                            valueACLcDiametro.length > 0
                          }
                          checked={allDiametrosSelected}
                          style={{ marginRight: 5 }}
                        />
                        {allDiametrosSelected
                          ? "Desmarcar todos"
                          : "Marcar todos"}
                      </li>
                    );
                  }
                  return (
                    <li key={key} {...optionProps}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 5 }}
                        checked={selected}
                      />
                      {option.label}
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Diámetros" />
                )}
              />
            </Grid>

            <Grid item xs={12} lg={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={listaPrecioData.ventaPorUnidad ?? false}
                    onChange={handleChange}
                    name="ventaPorUnidad"
                    color="primary"
                    disabled={["view", "enable", "disable", "mark-as-reference"].includes(actionCrud)}
                  />
                }
                label="Se vende por unidad"
              />
            </Grid>
          </Grid>

          {["new", "update"].includes(action) && (
            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-start", ml: 1, mb: 2 }}
              >
                <Tooltip title="nuevo rango">
                  <span>
                    <Button
                      className="btn-add"
                      variant="contained"
                      onClick={() => handleClickRango({}, "new")}
                      startIcon={<Add />}
                    >
                      Rango
                    </Button>
                  </span>
                </Tooltip>
              </Box>
            </Grid>
          )}

          <Grid container spacing={1} sx={{ ml: 1, mb: 2 }} >
            <Grid item xs={12}>
              <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  Rangos
                </Typography>
                <DataGrid
                  rows={rangosList}
                  columns={tableColumns}
                  {...tableOptions}
                />
              </Box>
            </Grid>

            <Grid item xs={12}>
              <TextField
                inputProps={{
                  autoComplete: "off",
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={listaPrecioData.observaciones ? listaPrecioData.observaciones.toUpperCase() : ""}
                onChange={handleChange}
                multiline
                rows={3}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: "80px",
                    minWidth: "400px",
                  },
                }}
                disabled={["view", "enable", "disable"].includes(actionCrud)}
              />
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}
            >
              {action !== "view" && (
                <>
                  {["new", "update"].includes(action) && (
                    <Button
                      sx={{ mr: 1 }}
                      variant="contained"
                      size="small"
                      onClick={() => handleSave(action)}
                      startIcon={<SaveIcon />}
                    >
                      Guardar
                    </Button>
                  )
                  }

                  {action === "disable" && (
                    <Button
                      sx={{ mr: 1 }}
                      variant="contained"
                      size="small"
                      onClick={() => handleSave(action)}
                      startIcon={<RemoveCircleOutlineIcon />}
                    >
                      Deshabilitar
                    </Button>
                  )}

                  {action === "enable" && (
                    <Button
                      sx={{ mr: 1 }}
                      variant="contained"
                      size="small"
                      onClick={() => handleSave(action)}
                      startIcon={<AddCircleOutlineIcon />}
                    >
                      Habilitar
                    </Button>
                  )}

                  {action === "mark-as-reference" && (
                    <Button
                      sx={{ mr: 1 }}
                      variant="contained"
                      size="small"
                      onClick={() => handleSave(action)}
                      startIcon={<Check />}
                    >
                      Marcar como de Referencia
                    </Button>
                  )}

                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleCancelar}
                    startIcon={
                      action === "view" ? <KeyboardReturn /> : <Cancel />
                    }
                  >
                    Cancelar
                  </Button>
                </>
              )}
            </Box>
          </Grid>
        </Grid>
      </Paper >

      {openRangoDialog && (
        <RangoDialog
          onSave={handleSaveRango}
          onClose={handleCloseRango}
          rangosList={rangosList}
          actionCrud={actionRangoDialog || actionCrud}
          itemCrud={itemCrud}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {openCorreccionesDialog && (
        <CorreccionesDialog
          onSave={handleSaveCorreccion}
          onClose={handleCloseCorrecciones}
          actionCrud={actionCorreccionesDialog || actionCrud}
          itemCrud={itemCrud}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {showMessage && (
        <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default ListaPrecioLenteContacto;